// web/src/components/ModuleMapModal/_highlight.tsx —— 内部：检索命中高亮渲染
// 拆自 web/src/components/ModuleMapModal.tsx 的同名分区（内容原样搬运）；由 web/src/components/ModuleMapModal.tsx 以 export * 聚合，导出面对调用方不变。

import { useEffect, useMemo, useRef, useState, type ComponentRef, type ReactNode } from 'react';
/** 名称命中高亮：把命中的片段包成 <mark>（检索已小写化，这里按长度切片，不引入正则） */
export function highlight(name: string, marks: string[]): ReactNode {
  if (marks.length === 0) return name;
  const lower = name.toLowerCase();
  const spans: Array<[number, number]> = [];
  for (const m of marks) {
    if (!m) continue;
    let from = 0;
    for (;;) {
      const at = lower.indexOf(m.toLowerCase(), from);
      if (at < 0) break;
      spans.push([at, at + m.length]);
      from = at + m.length;
    }
  }
  if (spans.length === 0) return name;
  spans.sort((a, b) => a[0] - b[0]);
  const merged: Array<[number, number]> = [];
  for (const s of spans) {
    const last = merged[merged.length - 1];
    if (last && s[0] <= last[1]) last[1] = Math.max(last[1], s[1]);
    else merged.push([...s] as [number, number]);
  }
  const out: ReactNode[] = [];
  let cursor = 0;
  merged.forEach(([from, to], i) => {
    if (from > cursor) out.push(name.slice(cursor, from));
    out.push(<mark key={`m${i}`}>{name.slice(from, to)}</mark>);
    cursor = to;
  });
  if (cursor < name.length) out.push(name.slice(cursor));
  return out;
}

